import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { UserProfile } from '@/types/user';

type ViewedUserInfoState = {
  data: UserProfile | null;
};

const initialState: ViewedUserInfoState = {
  data: null,
};

const viewedUserInfoSlice = createSlice({
  name: 'viewedUser',
  initialState,
  reducers: {
    setViewedUser(state, action: PayloadAction<UserProfile | null>) {
      state.data = action.payload;
    },
    clearViewedUser(state) {
      state.data = null;
    },
  },
});

export const { setViewedUser, clearViewedUser } = viewedUserInfoSlice.actions;
export default viewedUserInfoSlice.reducer;
